import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Welcome.css';
import config from "../../config";
import { getProjectCategory, getProjectApi, getItemListSize, putProjectViewCount } from "../../api";
const Welcome = () => {



  return (
    <section className="welcome-section py-4">
      <Container>
        <Row className="align-items-start">
          <Col md={4}>
            <div className="welcome-image-container">
              <img
                src="images/cdtst/cts_anasayfa.jpg"
                alt="Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi Binası"
                className="welcome-image"
              />
            </div>
          </Col>
          <Col md={8}>
            <h2 className="welcome-title">Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi'ne Hoş Geldiniz</h2>
            <div className="welcome-text">
              <p>
                Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi Projesi’nin temel amacı, Türkiye Cumhuriyeti dönemindeki
                sanatı araştırmak, belgelemek, anlamak, yaymak suretiyle sanat tarihine ve kültürel mirasa katkıda bulunmak
                ve bu alanda çalışan öncelikli olarak öğrencilere, bu alanda çalışan akademisyenlere, öğretmenlere ve sanata
                ilgi duyan herkese güvenilir, kolay ulaşılabilir bir açık kaynak sağlamaktır.
              </p>
              <p>
                Atatürk Kültür Merkezi Başkanlığının Türk kültürünü bilimsel yöntemlerle araştırmak, tanıtmak, yaymak ve bu
                alandaki kişi ve kuruluşları destekleyip onlarla iş birliği yapmak misyonu ve Türk kültürü araştırmalarında ulusal
                ve uluslararası düzeyde en yetkin Kurumlardan biri olmak; kültürümüzün temel değerlerini yaşatarak milli
                kültürü çağdaş medeniyetler seviyesi üzerine çıkarmak vizyonunu göz önüne alarak; Kurumumuzun kurulduğu
                günden günümüze  değin yayınlarımız ve çalışmalarımız arasında projemizde sözü edilen döneme ait çıktıların
                oldukça kısıtlı oluşu Cumhuriyetimizin 100. yılına yakışır bir projeyi gerçekleştirme sorumluluğunu Kurumumuza
                yüklemektedir.
              </p>
            </div>
            {/* <a href="#details" className="read-more">devamını oku...</a> */}
          </Col>
        </Row>



      </Container>
    </section>
  );
};

export default Welcome; 